import { PIPUploadResults } from '../../../src/components'

export default function Index() {
  return (
    <div className="cure-inner-container">
      <PIPUploadResults />
    </div>
  )
}
